import styled from 'styled-components';

import { PageBox } from '../../styles';

export const PageServicos = styled(PageBox)``;
